import PropTypes from 'prop-types';
import ReactDropdown from 'react-dropdown';
import { Box } from '@rebass/emotion';
import styles from './DropDown.styles';

const arrow = () => <Box css={styles.arrow} />;

const Dropdown = ({
  onChange,
  value,
  options,
  placeholder,
  className,
  menuClassName,
}) => (
  <Box css={styles.wrapper}>
    <ReactDropdown
      css={styles.dropdownStyles}
      className={className}
      controlClassName="dropdown-control"
      placeholderClassName="dropdown-placeholder"
      menuClassName={`dropdown-menu ${menuClassName}`}
      arrowClassName="dropdown-arrow"
      arrowClosed={arrow()}
      arrowOpen={arrow()}
      options={options}
      onChange={({ value: newValue }) => onChange(newValue)}
      value={value}
      placeholder={placeholder}
    />
  </Box>
);

Dropdown.defaultProps = {
  value: undefined,
  placeholder: undefined,
  className: undefined,
  menuClassName: '',
  onChange: () => {},
};

Dropdown.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])
  ).isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  menuClassName: PropTypes.string,
};

export default Dropdown;
